module.exports = __webpack_public_path__ + "static/media/Zafran Logo - White.810aaa04.png";